import * as React from "react";
import i18n from "i18n";
import { ActivitySearchService } from "modules/activitySearch/ActivitySearchService";
import { ActivitySearchStore } from "modules/activitySearch/ActivitySearchStore";
import MenuInputSearch from "common/components/fields/MenuInputSearch";
import RateLibrary from "modules/activitySearch/components/layouts/RateLibrary";
import Activity from "modules/activitySearch/components/layouts/Activity";
import { WBSStore } from "modules/WBS/WBSStore";
import { LoginStore } from "modules/login/LoginStore";
import { ToolbarStore } from "modules/WBS/ToolbarStore";
import { ToolbarTaskStore } from "modules/WBS/ToolbarTaskStore";
import { WBSPropertiesStore } from "modules/WBS/WBSPropertiesStore";
import axios from "axios";
import {
  withStyles,
  Dialog,
  DialogContent,
  Button,
  TableCell,
  DialogActions,
} from "@material-ui/core";
import { EWBSView } from "common/enums";
import { roundBy, sum, times } from "utils/DecimalUtils";
import { formatMonetary, formatNumber } from "utils/MathUtils";

const styles = (theme) => ({
  container: {
    display: "grid",
    gridTemplateRows: "auto 1fr",
    "& > :last-child": {
      overflowY: "auto" as any,
      overflowX: "hidden" as any,
    },
  },
  cellWrapper: {
    cursor: "default",
    transition: "all 0.3s ease-in",
    "&:hover": {
      backgroundColor: "white",
      "& > img": {
        opacity: 1,
      },
    },
    position: "sticky" as any,
    top: "0px",
    background: "white",
    zIndex: 10 as any,
  },
  title: {
    fontFamily: "Raleway",
    fontSize: "10px",
    fontWeight: 700,
    backgroundColor: "#2E2D2F",
    color: theme.palette.primary.light,
    padding: "10px 18px",
    textTransform: "uppercase" as any,
    display: "table",
    letterSpacing: "1px",
  },
});

type IProps = {
  classes: any;
};

// @observer
class ActivitySearch extends React.Component<IProps> {
  state = {
    wbs: false,
    lastValueSearch: "",
    openDialog: false,
    selectedItem: undefined,
    itemList: [],
  };

  componentDidMount() {
    this.getRateLibraries();
  }

  async getRateLibraries() {
    ActivitySearchStore.forceUpdate = this.forceUpdate.bind(this);
    await ActivitySearchStore.fetchRateLibraries();
    this.setState({ ready: true });
  }

  handleChange = async (value) => {
    let valueSearch: string = value;
    ActivitySearchStore.search = valueSearch;
    if (valueSearch.length >= 2) {
      if (!ActivitySearchStore.filteredTasksDispatch) {
        ActivitySearchStore.getFilteredTasks(valueSearch, this.state.wbs);
        this.setState({ lastValueSearch: valueSearch });
      }
    } else {
      ActivitySearchStore.handleClean();
      this.setState({ lastValueSearch: "" });
    }
  };

  hangleSwitchChange = (item) => (e, checked) => {
    item.data.active = checked;
    this.forceUpdate();
    if (checked) this.handleChange(this.state.lastValueSearch);
  };

  hangleSwitchWBSChange = async (e, checked) => {
    await this.setState({ wbs: checked });
    if (this.state.wbs) await this.handleChange(this.state.lastValueSearch);
  };

  /**
   * @description Abre o dialog com os recursos da atividade
   * @param item
   */
  async openDialog(item) {
    WBSStore.loading = true;
    let resourceList: any = await axios.post(
      `${process.env.REACT_APP_GET_RESOURCES_LIST}`,
      {
        data: item,
      }
    );

    let newList = resourceList.data.resourceList;
    item = resourceList.data;
    item.laborTotal = 0;
    item.equipmentTotal = 0;
    item.materialTotal = 0;
    item.otherTotal = 0;
    item.totalSum = 0;

    for (let i = 0; i < newList.length; i++) {
      const element = newList[i];
      let valueToSum = element.quantityInProject * element.unityCost;
      if (element.class == "labor") {
        item.laborTotal = sum(item.laborTotal, valueToSum);
      } else if (element.class == "equipment") {
        item.equipmentTotal = sum(item.equipmentTotal, valueToSum);
      } else if (element.class == "material") {
        item.materialTotal = sum(item.materialTotal, valueToSum);
      } else {
        item.otherTotal = sum(item.otherTotal, valueToSum);
      }
    }

    item.totalSum =
      item.laborTotal +
      item.equipmentTotal +
      item.materialTotal +
      item.otherTotal;

    this.setState({
      selectedItem: item,
      openDialog: true,
      itemList: resourceList.data.composition,
    });

    WBSStore.loading = false;
  }
  insereComposicao = (itm, font) => {
    if (WBSStore.selectedLine.data.parentTask) {
      // Verifica se a linha selecionada realmente pertence a task aberta
      if (WBSStore.selectedLine.data.parentTask !== WBSStore.task.id) return;
      ToolbarTaskStore.handelActions(
        ActivitySearchStore.handleSelected(itm, font),
        {
          originalOperation: "handleSelected",
          undoOperation: "deleteTaskRow",
          data: {
            undoFunction: {
              function: "deleteTaskRow",
              params: [],
              selectedLine: [],
            },
            originalFunction: {
              function: "handleSelected",
              params: [itm, font],
            },
          },
        }
      );
    } else {
      ActivitySearchStore.handleSelected(itm, font);
      ToolbarStore.handelActions({
        originalOperation: "handleSelected",
        undoOperation: "deleteWBSRow",
        data: {
          undoFunction: {
            function: "deleteWBSRow",
            params: [],
            selectedLine: [],
          },
          originalFunction: {
            function: "handleSelected",
            params: [itm, font],
          },
        },
      });
    }
  };

  render() {
    const { classes } = this.props,
      { selectedItem, itemList }: any = this.state,
      { rateLibraries, wbsResources, wbsTasks, handleClean } =
        ActivitySearchStore;

    const isTrial = LoginStore.isTrialUser();

    const tableCell = (name, width, alignLeft?) => {
      let tAlign = alignLeft ? "left" : "right"; // : 'center'
      let padding = 10; // 15

      return (
        <TableCell
          className={classes.cellWrapper}
          key={`header_${name}`}
          style={{
            textAlign: tAlign as any,
            width,
            padding,
            float: "left",
          }}
        >
          <div
            style={{
              textAlign: tAlign as any,

              fontFamily: "Roboto",
              fontStyle: "normal",
              fontWeight: "normal",
              fontSize: "14px",
              lineHeight: "16px",
              color: "#616161",
            }}
          >
            {name}
          </div>
        </TableCell>
      );
    };

    const tableCol = (name, width, alignLeft?, isTask?) => {
      let tAlign = alignLeft ? "left" : "right"; // : 'center'
      let padding = 10; // 15
      let textDecoration = "underline";

      return (
        <div
          className={classes.cellWrapper}
          key={`header_${name}`}
          style={{
            textAlign: tAlign as any,
            width,
            padding,
            float: "left",
            borderBottom: "1px solid #E0E0E0",
          }}
        >
          <div
            style={{
              textAlign: tAlign as any,
              fontFamily: "Roboto",
              fontStyle: "normal",
              fontWeight: "normal",
              fontSize: "14px",
              lineHeight: "16px",
              color: "#616161",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              textDecoration: isTask ? textDecoration : "none",
            }}
          >
            {name.toUpperCase()}
          </div>
        </div>
      );
    };

    const tableTotal = (title, sum, isBold?) => {
      return (
        <>
          {isBold && <hr style={{ marginTop: "2px" }}></hr>}
          <div
            style={{
              paddingBottom: "4px",
              fontWeight: isBold ? "normal" : 300,
            }}
          >
            <div
              style={{
                width: "50%",
                float: "left",
                paddingLeft: "12px",
              }}
            >
              {title}
            </div>
            <div
              style={{
                width: "50%",
                float: "left",
                textAlign: "right",
                paddingRight: "12px",
              }}
            >
              {formatNumber(roundBy(sum, WBSPropertiesStore.getRules(2)))}
            </div>
          </div>
        </>
      );
    };

    return (
      <>
        <Dialog
          open={this.state.openDialog ? true : false}
          onClose={() => this.setState({ openDialog: false })}
          maxWidth="xl"
          fullWidth={false}
          aria-labelledby="form-dialog-title"
          PaperProps={{
            style: {
              backgroundColor: "#fff",
              width: "1000px",
            },
          }}
        >
          <></>
          {selectedItem && (
            <>
              <DialogContent
                style={{
                  width: "100%",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    height: "100px",
                  }}
                >
                  <div
                    style={{
                      float: "left",
                      width: "60%",
                      fontFamily: "Roboto",
                      fontStyle: "normal",
                      fontWeight: 500,
                      fontSize: "16px",
                      lineHeight: "19px",
                      color: "#424242",
                    }}
                  >
                    {selectedItem.data.description}
                  </div>
                  <div
                    style={{
                      float: "left",
                      width: "20%",
                      fontFamily: "Roboto",
                      fontStyle: "normal",
                      fontWeight: 500,
                      fontSize: "16px",
                      lineHeight: "19px",
                      color: "#424242",
                      textAlign: "center",
                    }}
                  >
                    {selectedItem.data.unity}
                  </div>
                  <div
                    style={{
                      float: "left",
                      width: "20%",
                      fontFamily: "Roboto",
                      fontStyle: "normal",
                      fontWeight: 300,
                      fontSize: "12px",
                      lineHeight: "14px",
                      color: "#000000",
                    }}
                  >
                    {tableTotal(
                      i18n.project.rightSideMenu.categories.equipment,
                      selectedItem.laborTotal
                    )}
                    {tableTotal(
                      i18n.project.rightSideMenu.categories.labor,
                      selectedItem.equipmentTotal
                    )}
                    {tableTotal(
                      i18n.project.rightSideMenu.categories.material,
                      selectedItem.materialTotal
                    )}
                    {tableTotal(
                      i18n.project.rightSideMenu.categories.other,
                      selectedItem.otherTotal
                    )}
                    {tableTotal(
                      i18n.syntheticReport.total,
                      selectedItem.totalSum,
                      true
                    )}
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                  }}
                >
                  {tableCell(i18n.project.rightSideMenu.code, "10%", true)}
                  {tableCell(i18n.resources.description, "37%", true)}
                  {tableCell(i18n.resources.unity, "10%")}
                  {tableCell(i18n.resources.quantity, "16%")}
                  {tableCell(i18n.resources.unitCost, "15%")}
                  {tableCell(i18n.resources.total, "12%")}
                </div>
                <div
                  style={{
                    height: "222px",
                    /* position: relative; */
                    overflow: "auto",
                    width: "100%",
                  }}
                >
                  {itemList.map((item, index) => (
                    <>
                      {tableCol(item.code, "10%", true)}
                      {tableCol(item.description, "37%", true)}
                      {tableCol(item.unity, "10%")}
                      {tableCol(
                        formatNumber(
                          roundBy(
                            parseFloat(item.coefficient.replace(",", ".")),
                            WBSPropertiesStore.getRules(10)
                          ),
                          2,
                          10
                        ),
                        "16%"
                      )}
                      {item.type == "TASK"
                        ? tableCol(
                            formatNumber(
                              roundBy(
                                item.unityCost,
                                WBSPropertiesStore.getRules(2)
                              )
                            ),
                            "15%",
                            false,
                            true
                          )
                        : tableCol(
                            formatNumber(
                              roundBy(
                                item.unityCost,
                                WBSPropertiesStore.getRules(2)
                              )
                            ),
                            "15%"
                          )}

                      {tableCol(
                        formatNumber(
                          times(
                            item.unityCost,
                            parseFloat(item.coefficient.replace(",", ".")),
                            WBSPropertiesStore.getRules(2)
                          )
                        ),
                        "12%"
                      )}
                    </>
                  ))}
                </div>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => this.setState({ openDialog: false })}
                  color="secondary"
                >
                  {i18n.cancel}
                </Button>
                <Button
                  disabled={
                    !(
                      WBSStore.tab === 0 &&
                      WBSStore.currentTab === EWBSView.EAP &&
                      WBSStore.isLoadingOperations === false &&
                      WBSStore.selectedLine.index != -1
                    )
                  }
                  onClick={() => {
                    this.insereComposicao(selectedItem, "RL");
                    this.setState({ openDialog: false });
                  }}
                  color="primary"
                >
                  {i18n.include}
                </Button>
              </DialogActions>
            </>
          )}
        </Dialog>
        <div
          className={classes.container}
          style={{ height: `calc(100vh - ${isTrial ? 68 : 33}px)` }}
        >
          <div className={classes.title}>
            {i18n.project.rightSideMenu.composition}
            <MenuInputSearch
              disabled={false}
              handleChange={this.handleChange}
              handleClean={() => handleClean()}
            />
          </div>
          <div>
            <RateLibrary
              description={i18n.project.rightSideMenu.thisWBS}
              switchProps={{
                value: "wbs",
                checked: this.state.wbs,
                onChange: this.hangleSwitchWBSChange,
              }}
            />
            {this.state.wbs && (
              <React.Fragment>
                {wbsResources.map((itm) => {
                  let description = `${itm.data.description} | ${formatMonetary(
                    itm.data.unitCost
                  )} ${itm.data.unit} `;

                  return (
                    <Activity
                      key={itm.id}
                      link={false}
                      openDialog={() => this.openDialog(itm)}
                      description={description}
                      descriptionLength={description.trim().length}
                      onClick={() => this.insereComposicao(itm, "WBS")}
                    />
                  );
                })}
                {wbsTasks.map((itm) => {
                  let description = `${itm.data.description} | ${formatMonetary(
                    itm.data.unitCost
                  )} ${itm.data.unit} `;
                  return (
                    <Activity
                      key={itm.id}
                      link={true}
                      openDialog={() => this.openDialog(itm)}
                      description={description}
                      descriptionLength={description.trim().length}
                      onClick={() => this.insereComposicao(itm, "WBS")}
                    />
                  );
                })}
              </React.Fragment>
            )}
            {rateLibraries.map((item) => (
              <React.Fragment key={item.id}>
                <RateLibrary
                  description={item.data.name}
                  switchProps={{
                    value: item.id,
                    checked: item.data.active,
                    onChange: this.hangleSwitchChange(item),
                  }}
                />
                {item.data.active &&
                  item.data.tasks.map((itm) => {
                    let description = `${
                      itm.data.description
                    } | ${formatMonetary(Number(itm.data.totalCost))} ${
                      itm.data.unity
                    } `;
                    return (
                      <Activity
                        key={itm.id}
                        link={itm.data.type === "TASK"}
                        isRl={true}
                        description={description}
                        openDialog={() => this.openDialog(itm)}
                        descriptionLength={description.trim().length}
                        onClick={() => this.insereComposicao(itm, "RL")}
                      />
                    );
                  })}
              </React.Fragment>
            ))}
          </div>
        </div>
      </>
    );
  }
}
export default withStyles(styles)(ActivitySearch);



// WEBPACK FOOTER //
// ./src/modules/activitySearch/components/pages/ActivitySearch.tsx